module.exports = __webpack_public_path__ + "static/media/megaphone-referral.2c4a4362.svg";